import { ALLOWED_FILE_TYPES, VALIDATION_RULES } from '../constants/externalPaymentConstants';
import { formatCurrency as formatCurrencyShared } from '../../../utils/formatUtils';

/**
 * Obtiene la fecha actual en formato YYYY-MM-DD
 * @returns {string} Fecha formateada
 */
export const getCurrentDate = () => {
  const today = new Date();
  return today.toISOString().substring(0, 10);
};

/**
 * Valida si un archivo es del tipo permitido
 * @param {File} file - Archivo a validar
 * @returns {boolean} True si es válido
 */
export const isValidFileType = (file) => {
  if (!file) return false;
  return ALLOWED_FILE_TYPES.some((type) => file.name.toLowerCase().endsWith(type));
};

/**
 * Valida el tamaño del archivo
 * @param {File} file - Archivo a validar
 * @returns {boolean} True si el tamaño es válido
 */
export const isValidFileSize = (file) => {
  if (!file) return false;
  return file.size <= VALIDATION_RULES.FILE_SIZE_LIMIT;
};

/**
 * Formatea un número como moneda
 * @param {number} amount - Monto a formatear
 * @returns {string} Monto formateado
 */
export const formatCurrency = (amount) => formatCurrencyShared(amount);

/**
 * Calcula si una fecha de pago está dentro del rango de vencimiento
 * @param {string} paymentDate - Fecha de pago en formato DD/MM/YYYY
 * @param {string} dueDate - Fecha de vencimiento
 * @param {string} previousDueDate - Fecha de vencimiento anterior (opcional)
 * @returns {boolean} True si está en el rango
 */
export const isPaymentInDueRange = (paymentDate, dueDate, previousDueDate = null) => {
  const payment = new Date(paymentDate.split('/').reverse().join('-'));
  const due = new Date(dueDate);

  if (previousDueDate) {
    const previousDue = new Date(previousDueDate);
    return payment > previousDue && payment <= due;
  }

  return payment <= due;
};

/**
 * Valida los datos del formulario de confirmación
 * @param {Object} formData - Datos del formulario
 * @returns {Object} Resultado de la validación
 */
export const validateFormData = (formData) => {
  const errors = [];

  VALIDATION_RULES.REQUIRED_FIELDS.forEach((field) => {
    if (!formData[field]) {
      errors.push(`El campo ${field} es requerido`);
    }
  });

  return {
    isValid: errors.length === 0,
    errors,
  };
};

/**
 * Resetea los campos del formulario
 * @returns {Object} Objeto con valores por defecto
 */
export const getDefaultFormValues = () => ({
  entidadRecaudadora: '',
  puntoDeVenta: '',
  electronicInvoice: false,
  fechaFactura: getCurrentDate(),
});

/**
 * Procesa los datos de respuesta de la API
 * @param {Object} response - Respuesta de la API
 * @returns {Object} Datos procesados
 */
export const processApiResponse = (response) => {
  return {
    invoices: response.invoices || [],
    updated_coupons: response.updated_coupons || [],
    errors: response.errors || [],
    summary: {
      totalInvoices: response.invoices?.length || 0,
      totalCoupons: response.updated_coupons?.length || 0,
      totalErrors: response.errors?.length || 0,
    },
  };
};
